import { View, Text } from "react-native";

type TagListProps = {
  tags: (string | null | undefined)[];
};

export function TagList({ tags }: TagListProps) {
  const validTags = tags.filter(Boolean) as string[];
  if (validTags.length === 0) return null;

  return (
    <>
      {validTags.map((tag) => (
        <View
          key={tag}
          className="border-border bg-accent rounded-full border px-4 py-2"
        >
          <Text className="text-tag-foreground text-sm font-medium capitalize">
            {tag}
          </Text>
        </View>
      ))}
    </>
  );
}
